import { render, staticRenderFns } from "./MonogramLoader.vue?vue&type=template&id=44568d4e&scoped=true&"
import script from "./MonogramLoader.vue?vue&type=script&lang=js&"
export * from "./MonogramLoader.vue?vue&type=script&lang=js&"
import style0 from "./MonogramLoader.vue?vue&type=style&index=0&id=44568d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44568d4e",
  null
  
)

export default component.exports